import BaseModel from './baseModel';

class jobownerJobModel extends BaseModel {
  // constructor(refs) {
  //   super(refs); 
  //   this.Id;
  //   this.Title;
  //   this.Description;
  //   this.Tel;
  //   this.Address;
  //   this.Images;
  //   this.SelectedImages;
  //   this.SelectedGuild;
  //   this.SelectedUser;
  //   this.MultiInput;
  // }
}

export default jobownerJobModel;


/** WEBPACK FOOTER **
 ** ./src/models/jobownerJob.js
 **/